import { Component, HostBinding } from '@angular/core';

@Component({
    selector: 'lui-dialog-content',
    template: ` <ng-content></ng-content> `,
    standalone: false
})
export class DialogContentComponent {
  @HostBinding('class') hostClasses = 'lui-dialog-content';
}
